import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { FC } from "react";

import Login from "./pages/Login.page";
import Dashboard from "./pages/Dashboard.page";
import Quejas from "./pages/REDECO/Queja.page";
import PanelReune from "./pages/REUNE/PanelReune.page";
import ConsultasIndex from "./pages/REUNE/ConsultasIndex.page";
import ReclamacionesIndex from "./pages/REUNE/ReclamacionesIndex.page";
import AclaracionIndex from "./pages/REUNE/AclaracionIndex.page";

// import CRA from "./pages/CRA.page";

const App: FC = () => {
  return (
    <Router>
      <Routes>
        
        {/* Publico */}
        <Route path="/" element={<Login />} />

        {/* privado */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/quejas" element={<Quejas />} />

        <Route path="/reune/panel" element={<PanelReune />} />
        <Route path="/reune/panel/consultas" element={<ConsultasIndex />} />
        <Route path="/reune/panel/reclamaciones" element={<ReclamacionesIndex />} />
        <Route path="/reune/panel/aclaraciones" element={<AclaracionIndex />} />     
        
      </Routes>
    </Router>
  );
}

export default App;
